import { render } from "./LessonsInClassRoom.vue?vue&type=template&id=9aa351f6&scoped=true"
import script from "./LessonsInClassRoom.vue?vue&type=script&lang=js"
export * from "./LessonsInClassRoom.vue?vue&type=script&lang=js"

import "./LessonsInClassRoom.vue?vue&type=style&index=0&id=9aa351f6&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Management_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aa351f6"]])

export default __exports__